import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import {
  MatSidenavContainer,
  MatSidenav,
  MatSidenavContent
} from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

import { NavbarComponent } from '@app/containers/navbar/navbar.component';
import { SidenavComponent } from '@app/containers/sidenav/sidenav.component';
import { AccountType } from '@accounts/models/account-type';
import { APP_STORE } from '@core/stores/app.store';
import { ModuleHasClientAccessPipe } from '@modules/pipes/module-has-client-access.pipe';
import { SeoService } from '@shared/services/seo.service';
import { ZendeskFloatingButtonComponent } from '@zendesk/components/zendesk-floating-button/zendesk-floating-button.component';
import { ZendeskService } from '@zendesk/services/zendesk.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,

    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,

    SidenavComponent,
    NavbarComponent,
    ZendeskFloatingButtonComponent
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ModuleHasClientAccessPipe]
})
export class AppComponent {
  readonly #seoService = inject(SeoService);
  readonly #appStore = inject(APP_STORE);
  readonly #zendeskService = inject(ZendeskService);

  readonly sidenavPinned = this.#appStore.sidenavPinned;
  readonly isSidenavDisplayed = computed(
    () =>
      this.#appStore.selectedAccount()?.accountType === AccountType.SystemAdmin
  );

  constructor() {
    this.#seoService.init();
    this.#zendeskService.initialize();
  }

  toggleSidenavPinned(): void {
    this.#appStore.toggleSidenavPinned();
  }
}
